import axios from "infra/http";
import { useQuery } from "react-query";
import { DadosPessoaPortaria } from "./../typings/index";

function useDadosPessoaPortaria(pessoaId?: string, portariaId?: string) {
  return useQuery(
    `/v1/portaria/dados-pessoa/${pessoaId}`,
    async () => {
      const { data } = await axios.get<DadosPessoaPortaria>(
        `/v1/portaria/dados-pessoa/${pessoaId}`,
        {
          params: {
            autorizacaoId: portariaId,
          },
        },
      );

      return data;
    },
    {
      enabled: !!pessoaId,
    },
  );
}

export default useDadosPessoaPortaria;
